console.log('slider-component.js loaded');

if (!customElements.get('slider-component')) {
  console.log('Defining slider-component custom element');
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      console.log('SliderComponent constructor called');

      this.slider = this.querySelector('[role="list"]');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      console.log('Elements found:', {
        slider: this.slider,
        prevButton: this.prevButton,
        nextButton: this.nextButton
      });

      if (!this.slider || !this.prevButton || !this.nextButton) {
        console.log('Missing elements, exiting constructor');
        return;
      }

      console.log('Initializing buttons');
      this.initButtons();
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.update();
    }

    initButtons() {
      console.log('initButtons called');
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      console.log('Event listeners attached');
    }

    onButtonClick(event) {
      event.preventDefault();
      const button = event.currentTarget;

      // Ensure buttons are never disabled for infinite looping
      this.prevButton.removeAttribute('disabled');
      this.nextButton.removeAttribute('disabled');

      const direction = button.name === 'next' ? 1 : -1;
      const scrollDistance = this.getScrollDistance();

      console.log('Button clicked:', button.name);
      console.log('Scroll distance:', scrollDistance);
      console.log('Slider info:', {
        scrollLeft: this.slider.scrollLeft,
        scrollWidth: this.slider.scrollWidth,
        clientWidth: this.slider.clientWidth
      });

      // Check if we're at the boundaries for looping (increased tolerance for better detection)
      const tolerance = 5;
      const isAtStart = this.slider.scrollLeft <= tolerance;
      const isAtEnd = this.slider.scrollLeft + this.slider.clientWidth >= this.slider.scrollWidth - tolerance;

      // Calculate where we would scroll to
      const targetScroll = this.slider.scrollLeft + (direction * scrollDistance);
      const wouldExceedEnd = targetScroll + this.slider.clientWidth > this.slider.scrollWidth;
      const wouldExceedStart = targetScroll < 0;

      if ((direction === -1 && isAtStart) || wouldExceedStart) {
        // Loop to end when clicking previous at start
        this.slider.scrollTo({
          left: this.slider.scrollWidth - this.slider.clientWidth,
          behavior: 'smooth'
        });
      } else if ((direction === 1 && isAtEnd) || wouldExceedEnd) {
        // Loop to start when clicking next at end
        this.slider.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else {
        // Normal scroll
        this.slider.scrollBy({
          left: direction * scrollDistance,
          behavior: 'smooth'
        });
      }
    }

    getScrollDistance() {
      // Get the width of one slide including gap
      const slide = this.slider.querySelector('li');
      if (!slide) {
        console.log('No slide found');
        return 0;
      }

      const slideWidth = slide.offsetWidth;
      const gap = parseFloat(window.getComputedStyle(this.slider).gap) || 0;

      console.log('Slide width:', slideWidth, 'Gap:', gap);
      return slideWidth + gap;
    }

    update() {
      if (!this.prevButton || !this.nextButton) return;

      // Don't disable buttons - allow looping
      // Buttons remain enabled at all times for infinite scrolling
      this.prevButton.removeAttribute('disabled');
      this.nextButton.removeAttribute('disabled');
    }
  }

  customElements.define('slider-component', SliderComponent);
}
